/* The mockup's `.menu-item`, `.menu-sep` and `.menu-label`. */
.item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  inline-size: 100%;
  block-size: var(--control-height);
  padding: 0 var(--space-2);
  border: 0;
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--text);
  font-size: var(--font-size-13);
  text-align: start;
  white-space: nowrap;
  cursor: pointer;
}

.item svg {
  color: var(--text-subtle);
}

.item:hover,
.item:focus-visible {
  background: var(--state-hover);
}

.item:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.item[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.5;
}

.itemLabel {
  flex: 1;
}

.danger,
.danger svg {
  color: var(--danger-text);
}

.separator {
  block-size: 1px;
  margin: var(--space-1);
  background: var(--border);
}

.menuLabel {
  padding: 6px var(--space-2) 2px;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
